// Email service using Brevo API
const BREVO_API_KEY = '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';
const BREVO_API_URL = 'https://api.brevo.com/v3/smtp/email';

export const sendLeadEmail = async (formData) => {
  try {
    const emailContent = `
      <h2>New Lead Form Submission</h2>
      <p><strong>Name:</strong> ${formData.fullName}</p>
      <p><strong>Phone:</strong> ${formData.phone}</p>
      <p><strong>Email:</strong> ${formData.email || 'Not provided'}</p>
      <p><strong>Brief:</strong> ${formData.brief || 'Not provided'}</p>
      <p><strong>UTM Source:</strong> ${formData.utm_source}</p>
      <p><strong>UTM Campaign:</strong> ${formData.utm_campaign}</p>
      <p><strong>Timestamp:</strong> ${formData.timestamp}</p>
    `;

    const emailPayload = {
      sender: {
        name: "OptimizeMyData Landing Page",
        email: "manu@optimizemydata.com"
      },
      to: [
        {
          email: "manu@optimizemydata.com",
          name: "Manu"
        }
      ],
      subject: `New Lead: ${formData.fullName} - ${formData.phone}`,
      htmlContent: emailContent,
      textContent: `
        New Lead Form Submission
        
        Name: ${formData.fullName}
        Phone: ${formData.phone}
        Email: ${formData.email || 'Not provided'}
        Brief: ${formData.brief || 'Not provided'}
        UTM Source: ${formData.utm_source}
        UTM Campaign: ${formData.utm_campaign}
        Timestamp: ${formData.timestamp}
      `
    };

    const response = await fetch(BREVO_API_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'api-key': BREVO_API_KEY
      },
      body: JSON.stringify(emailPayload)
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(`Brevo API error: ${errorData.message || response.statusText}`);
    }

    const result = await response.json();
    console.log('Email sent successfully:', result);
    return result;

  } catch (error) {
    console.error('Error sending email:', error);
    throw error;
  }
};
